const {getAsset} = require("utils");
const prefix = "projects/tictactoe/";

module.exports =
{
	title: "TicTacToe",
	website: "http://anguterman.com/tictactoe",
	slogan: "",
	sections:
	[
		{
			title: "The Checklist",
			body:
			`In my high school AP Computer Science, one of our homework assignments was to create a TicTacToe game in Java. The expectation was that
			the board would be printed with a combination of dashes, slashes, and X and O characters, and that two players would be able to type their
			desired move into the console. For example, '3,3' would place a piece at the 3rd row in the 3rd column depending on whose turn it was.
			This was the requirement to receive full credit on the assignment, and there was 1 point of extra credit if you created any kind of AI,
			which could be of any skill level, including one that made their move in a random spot.`
		},
		{
			image: getAsset(prefix + "lame-game.jpg"),
		},
		{
			title: "Stepping Up",
			body:
			`From the beginning I knew that I didn't want to make my game a boring and text-based. I jumped at the opportunity to use a graphical
			Java framework called <strong>Processing</strong>. Processing gives developers easy access to the Java Graphics API, which lets you
			create windows of various sizes, draw and color basic shapes, and interact with the mouse and keyboard. I created my entire game
			in Processing so that there were actual buttons you could press to play the game and you could easily see, visually, the state of
			the game.`,
		},
		{
			image: getAsset(prefix + "cover.png"),
		},
		{
			title: "Cold Seat",
			body:
			`It was predetermined that I would go for the AI extra credit opportunity. In the main menu, the player is greeted with a screen that prompts
			them to select the type of game they want to play. The choices range from playing against someone next to them, labeled "2 player hotseat,"
			or they can choose to play against 3 various levels of AI: <strong>Easy, Medium, and Hard</strong>. Easy alone fulfilled the extra credit
			requirement in that it simply selected a random spot on the grid to place its piece. I could have stopped there, but I didn't take this
			class to coast through the assignments. The medium AI has no "dedicated logic." It flips a coin and 50% of the time plays like the easy AI,
			and the other 50% of the time it plays like the hard AI. The hard AI was where I spent most of my time with the assignment.`,
		},
		{
			title: "Intelligent AI",
			body:
			`<strong>The hard AI is unbeatable and ruthless.</strong> If you give it the opportunity to win, it will. It uses an algorithm called
			<strong>"Minimax"</strong> to determine the best possible move given a particular board state. The way the algorithm works is that
			it tries to find the "score" of each move. In TicTacToe, this score is clear: if the AI wins the score is 1, if the AI loses the score
			is -1, and otherwise the score is 0. The AI goes through every possible piece placement and calculates the score for that resulting board,
			and if the score is 0 (nobody has won), it calculates the score for every possible piece placement of that board, and so on until the score
			is non-zero. <strong>Once it finishes all of these calculations, it places its piece in the spot it determined had the highest
			score.</strong>`,
		},
		{
			image: getAsset(prefix + "winner-strikethrough.gif"),
		},
		{
			title: "Interface Quirks",
			body:
			`Aside from the obvious difficulty of creating the hard AI, the interface took a lot of work because in Processing, <strong>positions
			are absolute</strong> and UI components are made of basic shapes. This means that if you want to evenly space your components with margins
			on both sides, there are a lot of precise calculations that you must perform. Animations are also a chore because there's no built-in
			functionality for that. One exampe of this is the red line that gets drawn when someone wins the game. To accomplish that, I had to track
			the starting time of the animation and in each frame, draw a line of length proportional to the time elapsed since the animation started
			divided by the time it took the animation to finish. This was only the animation part of the line. This doesn't include setting the start
			and end positions to be the middle of the squares that were part of the winning three-in-a-row pieces. All of these manual UI calculations
			made me appreciate the relative developer-friendliness of web technologies such as HTML and CSS which make tasks like this easier.`,
		}
	],
};


// WEBPACK FOOTER //
// ./src/js/cases/TicTacToe.js